<div class="tw-w-full tw-px-[5px] sm:tw-px-[10px]">
    <p-carousel
        [value]="smeSuccessStories"
        [numVisible]="1"
        [numScroll]="1"
        [circular]="true"
        [showNavigators]="false"
        [showIndicators]="true"
        [autoplayInterval]="5000"
        contentClass="mobile-carousel"
    >
        <ng-template let-item pTemplate="item">
            <div
                class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-[15px] sm:tw-gap-[20px] md:tw-gap-[23px] tw-bg-white tw-rounded-[15px] tw-shadow-md tw-overflow-hidden tw-mx-[5px] sm:tw-mx-[10px] tw-cursor-pointer hover:tw-shadow-lg tw-transition-shadow tw-duration-300 tw-h-[360px] md:tw-h-[227px]"
                (click)="onStoryClick(item)"
            >
                <!-- Image Section -->
                <img
                    [src]="item.image"
                    [alt]="item.title"
                    class="tw-w-full tw-h-[180px] md:tw-h-full sm:tw-w-[200px] md:tw-w-[250px] lg:tw-w-[278px] lg:tw-h-full tw-object-cover tw-flex-shrink-0 xl:tw-block tw-hidden"
                />
                <img
                    [src]="item.pImage"
                    [alt]="item.title"
                    class="tw-w-full tw-h-[180px] md:tw-h-full sm:tw-w-[200px] md:tw-w-[250px] lg:tw-w-[278px] lg:tw-h-full tw-object-cover tw-flex-shrink-0 xl:tw-hidden md:tw-block tw-hidden"
                />
                <img
                    [src]="item.mImage"
                    [alt]="item.title"
                    class="tw-w-full tw-h-[180px] md:tw-h-full sm:tw-w-[200px] md:tw-w-[250px] lg:tw-w-[278px] lg:tw-h-full tw-object-cover tw-flex-shrink-0 md:tw-hidden tw-block"
                />

                <!-- Content Section -->
                <div
                    class="tw-p-[15px] sm:tw-p-[18px] md:tw-p-[20px] tw-flex tw-flex-col tw-gap-[10px] sm:tw-gap-[12px] tw-flex-1 tw-h-full"
                >
                    <span
                        class="tw-text-[14px] sm:tw-text-[15px] md:tw-text-[16px] tw-font-bold tw-text-[#000000CC] tw-leading-[20px] sm:tw-leading-[21px] md:tw-leading-[22px]"
                    >
                        {{ item.title }}
                    </span>
                    <span
                        [innerHTML]="item.shortdesc"
                        class="tw-text-[12px] sm:tw-text-[13px] md:tw-text-[14px] default-html tw-font-normal tw-text-[#000000CC] tw-leading-[18px] sm:tw-leading-[19px] md:tw-leading-[20px] tw-line-clamp-3 sm:tw-line-clamp-4"
                    >
                    </span>
                </div>
            </div>
        </ng-template>
    </p-carousel>
</div>
